import { useInfiniteQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
interface IUseFetchIdentifications {
  relations?: string[];
  sortBy?: string[];
  extraFilters?: Record<string, string | number | undefined>;
  limit?: number;
  search?: string;
  id?: string;
  fields?: string[];
  type: string;
}
export const useFetchIdentifications = (params: IUseFetchIdentifications) => {
  const fetchIdentifications = async ({ pageParam = 1 }) => {
    const { relations: partiesRelations, id, extraFilters: filters, type, ...rest } = params;
    const queryString = new URLSearchParams(
      Object.keys(rest)?.length ? toQueryString(rest as QueryParamObject) : '',
    );

    Object.entries(filters ?? {}).forEach(([key, value]) => {
      if (value) queryString.append(`filter.${key}`, String(value));
    });

    (partiesRelations ?? []).forEach((rel) => queryString.append('relations', rel));

    queryString.append('page', String(pageParam));
    const url =
      type === 'matter'
        ? `${API_URLS.MATTER_IDENTIFICATIONS.replace(':id', String(id))}?${queryString.toString()}`
        : `${API_URLS.MATTER_REQUEST_IDENTIFICATIONS.replace(':id', String(id))}?${queryString.toString()}`;
    try {
      return await get(url);
    } catch (error) {
      console.error('Error fetching matter parties:', error);
      throw new Error((error as { message: string }).message || 'Failed to fetch matter parties');
    }
  };

  const {
    data,
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  } = useInfiniteQuery({
    initialPageParam: 1,
    queryKey: ['identifications-list', params],
    queryFn: fetchIdentifications,
    getNextPageParam: (lastPage, allPages) => {
      const totalCount = lastPage?.meta?.totalItems ?? 0;
      const fetchedCount = allPages.flatMap((page) => page.data).length;
      return fetchedCount < totalCount ? allPages.length + 1 : undefined;
    },
  });
  return {
    data: data?.pages.flatMap((page) => page.data) ?? [],
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  };
};
